import { render, staticRenderFns } from "./BaseTextViewer.vue?vue&type=template&id=34278b60&scoped=true"
import script from "./BaseTextViewer.vue?vue&type=script&lang=js"
export * from "./BaseTextViewer.vue?vue&type=script&lang=js"
import style0 from "./BaseTextViewer.vue?vue&type=style&index=0&id=34278b60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34278b60",
  null
  
)

export default component.exports